module.exports = __webpack_public_path__ + "static/pltw-capstone-cost-analysis-9c664a7d1c71797cf5c0bbf2816e6e6e.png";